<template>
  <div>
    <section class="page-title" v-if="!exibeformulario">
      <br>
      <div class="center imagemBanner ">
        <p class="label-planos">Credenciamento online</p>
        <h1 class="the-title">Junte-se a família <span>Primavida</span></h1>
        <p>Escolha a modalidade abaixo e credencie-se agora mesmo!</p>
        <br>
        <v-btn style="border-radius: 6px;" dark large @click="iniciarCredenciamento('fisica')" color="#009b9b" :loading="loading">Pessoa Física</v-btn>
        <v-btn style="border-radius: 6px;" dark large @click="iniciarCredenciamento('juridica')" color="#cc9f52" :loading="loading">Pessoa Jurídica</v-btn>
      </div>
    </section>
    <div class="center" v-else>
      <br>
      <v-flex xs12 sm12 lg12>
        <div class="plano-selecionado" style="background: #f1f1f1;color:#009b9b;"><span >CREDENCIAMENTO PESSOA {{tipoContrato}}</span></div>
        <v-stepper v-model="e1"  style="border-radius: 10px;">
          <v-stepper-header>
            <v-stepper-step :complete="e1 > 1" step="1" :editable="editPassos" >Identificação</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 2" step="2" :editable="editPassos">Endereço</v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="e1 > 3" step="3" :editable="editPassos">Anexos</v-stepper-step>
            <v-divider v-if="tipoContrato == 'JURÍDICA'"></v-divider>
            <v-stepper-step v-if="tipoContrato == 'JURÍDICA'" :complete="e1 > 4" step="4" :editable="editPassos">Corpo Clínico</v-stepper-step>
            <!-- <v-divider v-if="tipoContrato == 'JURÍDICA'"></v-divider>
            <v-stepper-step :complete="e1 > 5" :step="tipoContrato == 'JURÍDICA' ? 5 : 4" :editable="editPassos">Conclusão</v-stepper-step> -->
          </v-stepper-header>
          <v-stepper-items>
            <!-- PASSO 1 -->
            <v-stepper-content step="1">
              <v-container grid-list-md>
                <v-card flat>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg6>      
                      <v-text-field
                        v-model="modelFilial.email"
                        v-validate="'required|email'"
                        :error-messages="errors.collect('email')"
                        label="E-mail*"
                        data-vv-name="email"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>      
                      <v-text-field
                        v-model="modelFilial.senha"
                        label="Senha*"
                        v-validate="'required'"
                        :error-messages="errors.collect('senha')"
                        type="password"
                        ref="password"
                        data-vv-name="senha"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>      
                      <v-text-field
                        v-model="confirmPassword"
                        label="Repetir Senha*"
                        type="password"
                        :error-messages="errors.collect('password')"
                        v-validate="'required|confirmed:password'"
                        data-vv-name="password"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.nomeEmpregado"
                        label="Nome Completo*"
                        box
                        v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                        :error-messages="errors.collect('firstName')"
                        data-vv-name="firstName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-else>      
                      <v-text-field
                        v-model="modelFilial.nm_razsoc"
                        label="Razão Social*"
                        box
                        v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                        :error-messages="errors.collect('firstName')"
                        data-vv-name="firstName"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.cro"
                        label="CRO*"
                        type="number"
                        v-validate="'required'"
                        :error-messages="errors.collect('cro')"
                        data-vv-name="cro"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg6 v-else>      
                      <v-text-field
                        label="CNPJ*"
                        v-model="modelFilial.nr_cgc"
                        v-validate="'required'"
                        :error-messages="errors.collect('cnpj')"
                        data-vv-name="cnpj"
                        return-masked-value mask="##.###.###/####-##"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.croDataExpedicao"
                        label="Data de Emissão do CRO*"
                        v-validate="{required: true, min: 10}"
                        return-masked-value mask="##/##/####"
                        :error-messages="errors.collect('emissao')"
                        data-vv-name="emissao"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.nr_identidade"
                        label="RG"
                        v-validate="'required'"
                        :error-messages="errors.collect('rg')"
                        data-vv-name="rg"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.nm_orgaoexp"
                        label="Órgão Emissor"
                        v-validate="'required'"
                        :error-messages="errors.collect('orgao')"
                        data-vv-name="orgao"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">           
                      <v-text-field
                        v-model="modelFuncionario.dt_nascimento"
                        label="Data de Nascimento"
                        v-validate="'required|date_format:dd/MM/yyyy'"
                        :error-messages="errors.collect('dateOfBirth')"
                        return-masked-value mask="##/##/####"
                        data-vv-name="dateOfBirth"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.nr_cpf"
                        label="CPF"
                        v-validate="'required|cpf'"
                        :error-messages="errors.collect('cpfFilial')"
                        return-masked-value mask="###.###.###-##"
                        data-vv-name="cpfFilial"       
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="tipoContrato == 'FÍSICA'">      
                      <v-text-field
                        v-model="modelFuncionario.nit_pis"
                        label="PIS"
                        type="number"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-else>      
                      <v-text-field
                        v-model="modelFilial.cnes"
                        label="CNES*"
                        type="number"
                        v-validate="'required'"
                        :error-messages="errors.collect('cnes')"
                        data-vv-name="cnes"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>      
                      <v-autocomplete
                        box
                        v-model="modelFilial.especialidades"
                        :items="especialidadeClinica"
                        multiple
                        item-text="text"
                        item-value="value"
                        label="Especialidades*"
                        v-validate="'required'"
                        :error-messages="errors.collect('especialidade')"
                        data-vv-name="especialidade"
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg8>
                      <v-text-field
                        v-model="modelFilial.contatos[0].NmContato"
                        label="Responsável técnico*"
                        box
                        v-validate="{ required: true, regex: /^((\b[A-zÀ-ú']{2,40}\b)\s*){2,}$/ }" name="regex"
                        :error-messages="errors.collect('responsavel')"
                        data-vv-name="responsavel"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>
                      <v-text-field
                        v-model="modelFilial.contatos[0].Telefone"
                        label="Telefone*"
                        return-masked-value mask="(##)#####-####"
                        v-validate="'required'"   
                        :error-messages="errors.collect('telefone')"
                        data-vv-name="telefone"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="tipoContrato == 'FÍSICA'">
                      <v-autocomplete
                        v-model="modelFuncionario.cd_banco"
                        label="Banco"
                        :items="bancos"
                        clearable
                        item-text="text"
                        item-value="value"
                        v-validate="'required'"   
                        :error-messages="errors.collect('bancoPF')"
                        data-vv-name="bancoPF"
                        box
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-else>
                      <v-autocomplete
                        v-model="modelFilial.cd_banco"
                        label="Banco"
                        :items="bancos"
                        clearable
                        item-text="text"
                        item-value="value"
                        v-validate="'required'"   
                        :error-messages="errors.collect('bancoPJ')"
                        data-vv-name="bancoPJ"
                        box
                      ></v-autocomplete>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="tipoContrato == 'FÍSICA'">
                      <v-text-field
                        v-model="modelFuncionario.nr_agencia"
                        label="Agência"
                        v-validate="'required'"   
                        :error-messages="errors.collect('agenciaPF')"
                        data-vv-name="agenciaPF"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-else>
                      <v-text-field
                        v-model="modelFilial.nr_agencia"
                        label="Agência"
                        v-validate="'required'"   
                        :error-messages="errors.collect('agenciaPJ')"
                        data-vv-name="agenciaPJ"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-if="tipoContrato == 'FÍSICA'">
                      <v-text-field
                        v-model="modelFuncionario.nr_conta"
                        label="Conta"
                        type="tel"
                        v-validate="'required'"   
                        :error-messages="errors.collect('contaPF')"
                        data-vv-name="contaPF"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4 v-else>
                      <v-text-field
                        v-model="modelFilial.nr_conta"
                        label="Conta"
                        type="tel"
                        v-validate="'required'"   
                        :error-messages="errors.collect('contaPJ')"
                        data-vv-name="contaPJ"
                        box
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-flex md12 xs12 sm12 lg3>
                    <v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="avancaPasso1()">Continuar</v-btn>
                  </v-flex> 
                </v-card>
              </v-container>
            </v-stepper-content>
            <!-- FIM DO PASSO 1 -->

            <!-- PASSO 2 --> 
            <v-stepper-content step="2">
              <v-container grid-list-md>
                <v-card flat>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg2>      
                      <v-text-field
                        v-model="cep"
                        label="CEP"
                        return-masked-value mask="#####-###"
                        v-validate="'required'"
                        :error-messages="errors.collect('cep')"
                        data-vv-name="cep"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg7>      
                      <v-text-field
                        :disabled="cep != ''"
                        v-model="modelFilial.endLogradouro"
                        label="Rua"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg3>      
                      <v-text-field
                        v-model="modelFilial.endNumero"
                        label="Número"
                        type="number"
                        v-validate="'required'"
                        :error-messages="errors.collect('numero')"
                        data-vv-name="numero"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>      
                      <v-text-field
                        :disabled="cep != ''"
                        v-model="bairro"
                        label="Bairro"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>      
                      <v-text-field
                        :disabled="cep != ''"
                        v-model="cidade"
                        label="Cidade"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg4>      
                      <v-text-field
                        :disabled="cep != ''"
                        v-model="estado"
                        label="Estado"
                        box
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm12 lg12>
                      <v-text-field
                        v-model="modelFilial.endComplemento"
                        label="Complemento"
                        box
                      ></v-text-field>
                    </v-flex>
                    <br>
                    <v-flex xs12 sm2 lg3>
                      <v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="avancaPasso2()">Continuar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-card>                
              </v-container>
            </v-stepper-content>
            <!-- FIM DO PASSO 2 -->

            <!-- PASSO 3 --> 
            <v-stepper-content step="3">
              <v-container grid-list-md>
                <v-card class="mb-5" min-height="200px" flat>
                  <v-layout row wrap>
                    <!-- RG1 -->
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file1"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesRg1"
                        @input-filter="inputFilter"
                        @input-file="inputFileRg1"
                        ref="upload1"
                      >
                        <p class="form-titulo" style="font-size: 20px">RG (FRENTE)*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);" v-if="tipoContrato == 'JURÍDICA'">Resp. Técnico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="rg1" value="" hidden></p>
                        <p v-if="filesRg1 == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesRg1" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>
                    </v-flex>

                    <!-- RG2 --> 
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file2"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesRg2"
                        @input-filter="inputFilter"
                        @input-file="inputFileRg2"
                        ref="upload2"
                      >
                        <p class="form-titulo" style="font-size: 20px">RG (VERSO)*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);" v-if="tipoContrato == 'JURÍDICA'">Resp. Técnico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="rg2" value="" hidden></p>
                        <p v-if="filesRg2 == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesRg2" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- CPF --> 
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file3"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesCPF"
                        @input-filter="inputFilter"
                        @input-file="inputFileCPF"
                        ref="upload3"
                      >
                        <p class="form-titulo" style="font-size: 20px">CPF*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);" v-if="tipoContrato == 'JURÍDICA'">Resp. Técnico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="cpf" value="" hidden></p>
                        <p v-if="filesCPF == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesCPF" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- CRO --> 
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file4"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesCRO"
                        @input-filter="inputFilter"
                        @input-file="inputFileCRO"
                        ref="upload4"
                      >
                        <p class="form-titulo" style="font-size: 20px">CRO*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);" v-if="tipoContrato == 'JURÍDICA'">Resp. Técnico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="cro" value="" hidden></p> 
                        <p v-if="filesCRO == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesCRO" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- INSS/PIS --> 
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file5"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesINSS"
                        @input-filter="inputFilter"
                        @input-file="inputFileINSS"
                        ref="upload5"
                      >
                        <p class="form-titulo" style="font-size: 20px">INSS/PIS*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="inss" value="" hidden></p>
                        <p v-if="filesINSS == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesINSS" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- CONTRATO SOCIAL --> 
                    <v-flex xs12 sm12 lg3 v-else>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file5"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesContrato"
                        @input-filter="inputFilter"
                        @input-file="inputFileContrato"
                        ref="upload5"
                      >
                        <p class="form-titulo" style="font-size: 20px">Contrato Social*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="contrato" value="" hidden></p>
                        <p v-if="filesContrato == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesContrato" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- ALVARA SANITARIO --> 
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file6"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesAlvaraSan"
                        @input-filter="inputFilter"
                        @input-file="inputFileAlvaraSan"
                        ref="upload6"
                      >
                        <p class="form-titulo" style="font-size: 20px">Alvará Sanitário*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="alvarasan" value="" hidden></p>
                        <p v-if="filesAlvaraSan == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesAlvaraSan" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- ALVARA DE FUNCIONAMENTO -->
                    <v-flex xs12 sm12 lg3>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file7"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesAlvaraFun"
                        @input-filter="inputFilter"
                        @input-file="inputFileAlvaraFun"
                        ref="upload7"
                      >
                        <p class="form-titulo" style="font-size: 20px">Alvará de Funcionamento*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="alvarafun" value="" hidden></p>
                        <p v-if="filesAlvaraFun == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesAlvaraFun" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- COMPROVANTE BANCÁRIO --> 
                    <v-flex xs12 sm12 lg3>    
                      <file-upload
                        class="btn btn-primary"
                        input-id="file8"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesComprovante"
                        @input-filter="inputFilter"
                        @input-file="inputFileComprovante"
                        ref="upload8"
                      >
                        <p class="form-titulo" style="font-size: 20px">Comprovante Bancário*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="comprovante" value="" hidden></p>
                        <p v-if="filesComprovante == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesComprovante" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- ESPECIALIZAÇÃO -->
                    <v-flex xs12 sm12 lg3>    
                      <file-upload
                        class="btn btn-primary"
                        input-id="file9"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesEspecializacao"
                        @input-filter="inputFilter"
                        @input-file="inputFileEspecializacao"
                        ref="upload9"
                      >
                        <p class="form-titulo" style="font-size: 20px">Título de Especialização*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);" v-if="tipoContrato == 'JURÍDICA'">Corpo Clínico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="especializacao" value="" hidden></p>
                        <p v-if="filesEspecializacao == ''">Nenhum arquivo selecionado</p>
                        <div v-else>
                          <p v-for="(file) in filesEspecializacao" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>
                      </file-upload>
                    </v-flex>

                    <!-- DIPLOMA --> 
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'FÍSICA'">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file10"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesDiploma"
                        @input-filter="inputFilter"
                        @input-file="inputFileDiploma"
                        ref="upload10"
                      >
                        <p class="form-titulo" style="font-size: 20px">Diploma*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="diploma" value="" hidden></p>
                        <p v-if="filesDiploma == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesDiploma" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>

                    <!-- RG, CPF, CRO --> 
                    <v-flex xs12 sm12 lg3 v-else>
                      <file-upload
                        class="btn btn-primary"
                        input-id="file10"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesDocCorpo"
                        @input-filter="inputFilter"
                        @input-file="inputFileDocCorpo"
                        ref="upload10"
                      >
                        <p class="form-titulo" style="font-size: 20px">RG, CPF e CRO*</p>
                        <p style="margin-top:-23px;color:rgb(211 179 30 / 1);">Corpo Clínico</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="docscorpo" value="" hidden></p>
                        <p v-if="filesDocCorpo == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesDocCorpo" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>
                      </file-upload>
                    </v-flex>

                    <!-- CNES --> 
                    <v-flex xs12 sm12 lg3 v-if="tipoContrato == 'JURÍDICA'">
                      <file-upload
                        class="btn btn-primary"
                        input-id="file11"
                        extensions="pdf,gif,jpg,jpeg,png,webp"
                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                        post-action="/upload/post"
                        v-model="filesCNES"
                        @input-filter="inputFilter"
                        @input-file="inputFileCNES"
                        ref="upload11"
                      >
                        <p class="form-titulo" style="font-size: 20px">CNES*</p>
                        <v-btn style="border-radius: 8px;" large dark color="#009b9b">Selecionar arquivo</v-btn>
                        <p id="cnes" value="" hidden></p>
                        <p v-if="filesCNES == ''">Nenhum arquivo selecionado</p>
                        <div v-else>                    
                          <p v-for="(file) in filesCNES" :key="file.id" style="color:#a3a0a0">{{file.name}}</p>
                        </div>              
                      </file-upload>                        
                    </v-flex>
                  </v-layout>
                </v-card>
                <v-btn v-if="tipoContrato == 'FÍSICA'" style="border-radius: 8px;" large dark color="#009b9b" @click="finalizarCredPF()">Finalizar e Enviar</v-btn>
                <v-btn v-if="tipoContrato == 'JURÍDICA'" style="border-radius: 8px;" large dark color="#009b9b" @click="avancaPasso3()">Continuar</v-btn>
              </v-container>
            </v-stepper-content>
            <!-- FIM DO PASSO 3 -->

            <!-- PASSO 4 -->
            <v-stepper-content step="4">  
              <v-container fluid grid-list-md>
                <v-data-iterator
                  v-if="modelFilial.corpoClinicoFilial != ''"
                  :items="modelFilial.corpoClinicoFilial"
                  :rows-per-page-items="rowsPerPageItems"
                  rows-per-page-text="Linhas por página" 
                  :pagination.sync="pagination"
                  content-tag="v-layout"
                  row
                  wrap
                  hide-actions
                >
                  <template v-slot:header>
                    <v-toolbar style="border-radius: 10px;" class="mb-2" color="#105586" dark flat>
                      <v-toolbar-title>Corpo Clínico</v-toolbar-title>
                    </v-toolbar>
                  </template>
                  <template v-slot:item="props">
                    <v-flex xs12 sm6 md4 lg4>
                      <v-card style="border-radius: 10px;">
                        <v-card-title style="justify-content: center;" class="subheading font-weight-bold">{{ props.item.nomeEmpregado.toUpperCase() }}</v-card-title>
                        <v-divider></v-divider>
                        <v-list dense>
                          <v-list-tile>
                            <v-list-tile-content class="centralizar" >CRO: {{props.item.cro}}</v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-list-tile-content class="centralizar" >CPF {{ props.item.nr_cpf }}</v-list-tile-content>
                          </v-list-tile>
                          <v-list-tile>
                            <v-btn style="border-radius: 8px;" dark color="blue-grey darken-1" @click="editItem(props.item)">Editar</v-btn>
                            <v-btn v-if="!props.item.titular" style="border-radius: 8px;" dark color="error" @click="openDialogDelete(props.item)">Excluir</v-btn>
                          </v-list-tile>
                        </v-list>
                      </v-card>
                    </v-flex>
                  </template>      
                </v-data-iterator>
              </v-container>
              <!-- DIALOG DA LISTA DE BENEFICIARIOS -->
              <v-flex xs12 sm12 lg12>
                <v-container grid-list-md v-if="!alertTitular">
                  <v-layout row wrap justify-center>
                    <v-btn @click="openDialogCorpoClinico()" dark style="border-radius: 8px;" large color="#cc9966">Incluir Corpo Clínico</v-btn>
                  </v-layout>
                </v-container>         
              </v-flex>
              <v-dialog v-model="dialog" max-width="950px" persistent>
                <v-card>
                  <v-card-title>
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>               
                        <v-flex xs12 sm12 lg6>      
                          <v-text-field
                            v-model="modelFuncionario.nomeEmpregado"
                            label="Nome Completo"
                            box
                            v-validate="'required'"
                            :error-messages="errors.collect('firstNameDep')"
                            data-vv-name="firstNameDep"
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg3>      
                          <v-text-field
                            v-model="modelFuncionario.nr_identidade"
                            label="RG"
                            v-validate="'required'"
                            :error-messages="errors.collect('rgCC')"
                            data-vv-name="rgCC"
                            box
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg3>      
                          <v-text-field
                            v-model="modelFuncionario.nm_orgaoexp"
                            label="Órgão Emissor"
                            v-validate="'required'"
                            :error-messages="errors.collect('orgaoCC')"
                            data-vv-name="orgaoCC"
                            box
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg3>      
                          <v-text-field
                            v-model="modelFuncionario.nr_cpf"
                            label="CPF"
                            v-validate="'required|cpf'"
                            :error-messages="errors.collect('cpfCC')"
                            return-masked-value mask="###.###.###-##"
                            data-vv-name="cpfCC"
                            box
                          ></v-text-field>
                        </v-flex>              
                        <v-flex xs12 sm12 lg3>      
                          <v-text-field
                            v-model="modelFuncionario.dt_nascimento"
                            label="Data de Nascimento"
                            v-validate="'required|date_format:dd/MM/yyyy'"
                            :error-messages="errors.collect('dateOfBirthCC')"
                            return-masked-value mask="##/##/####"
                            data-vv-name="dateOfBirthCC"
                            box
                          ></v-text-field>
                        </v-flex>                            
                        <v-flex xs12 sm12 lg3>      
                          <v-text-field
                            v-model="modelFuncionario.cro"
                            label="CRO"
                            v-validate="'required'"   
                            :error-messages="errors.collect('cro')"
                            data-vv-name="cro" 
                            box
                          ></v-text-field>
                        </v-flex> 
                        <v-flex xs12 sm12 lg3>
                          <v-text-field
                            v-model="modelFuncionario.croDataExpedicao"
                            label="Data Emissão CRO"            
                            v-validate="{required: true, min: 10}"
                            return-masked-value mask="##/##/####"  
                            :error-messages="errors.collect('emissao')"
                            data-vv-name="emissao"       
                            box
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg12>      
                          <v-autocomplete
                            box               
                            v-model="modelFuncionario.especialidades"
                            :items="especialidadeClinica"
                            multiple
                            item-text="text"
                            item-value="value"
                            label="Especialidades*"
                            v-validate="'required'"
                            :error-messages="errors.collect('especialidadeCC')"
                            data-vv-name="especialidadeCC"
                          ></v-autocomplete>
                        </v-flex>                                                                                   
                        <v-flex xs12 sm12 lg4>
                          <v-autocomplete
                            v-model="modelFuncionario.cd_banco"
                            label="Banco"
                            :items="bancos"
                            clearable
                            item-text="text"
                            item-value="value"
                            v-validate="'required'"   
                            :error-messages="errors.collect('banco')"
                            data-vv-name="banco"
                            box
                          ></v-autocomplete>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            v-model="modelFuncionario.nr_agencia"
                            label="Agência"
                            v-validate="'required'"   
                            :error-messages="errors.collect('agencia')"
                            data-vv-name="agencia"
                            box
                          ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 lg4>
                          <v-text-field
                            v-model="modelFuncionario.nr_conta"
                            label="Conta"
                            type="tel"
                            v-validate="'required'"   
                            :error-messages="errors.collect('conta')"
                            data-vv-name="conta"
                            box
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>        
                    <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="salvarCorpoClinicoPJ">Salvar</v-btn>
                    <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- FIM DIALOG DEPENDENTES --> 

              <!-- DIALOG DELETA DEPENDENTE -->
              <v-dialog v-model="dialogDelete" max-width="600px" persistent>
                <v-card>
                  <v-card-title>
                    <span class="headline">Confirmação de Exclusão</span>
                  </v-card-title>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <v-card-text>Dependente: {{}}</v-card-text>
                        <v-card-text>Parentesco: {{}}</v-card-text>
                      </v-layout>
                    </v-container>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn dark color="red darken-1" style="border-radius: 8px; width: 130px;" @click.native="deleteDependente(dependents.firstName)">Excluir</v-btn>
                    <v-btn dark color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" @click.native="close">Cancelar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
              <!-- FIM DIALOG DELETA DEPENDENTE -->     
          
              <br>
              <div class="separator dark"></div>
              <!-- <v-container grid-list-md>
                <v-layout row wrap justify-center>
                  <v-flex xs12 sm12 lg12>
                    <div class="total-table">
                      <p class="form-titulo">Valores</p>
                      <div class="row-table-wrapper">
                        <div class="col" style="width: 36%;">
                          <div class="row-table titular" >
                            <p>Beneficiário Titular</p>
                            <span class="total">R$ 15,00</span>
                          </div>
                          <div class="row-table dependentes-row">
                            <p>Dependente(s)</p>
                            <span class="total">R$ {{}}</span>
                          </div>
                        </div>
                      
                        <div class="col" style="margin-right: 14%;">
                          <div class="row-table total-row">
                            <p>Total a pagar</p>
                            <span class="total">R$ {{}}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <hr>
                    <br>
                  </v-flex>
                </v-layout>
              </v-container>  -->   
              <!-- FIM DO DIALOG DA LISTA DE BENEFICIARIOS -->
              <v-card-actions>
                <v-flex md12 xs12 sm12 lg3>
                  <v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="finalizarCred()">Finalizar e Enviar</v-btn>
                  <!-- <v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="avancaPasso4()">Continuar</v-btn> -->
                </v-flex>
              </v-card-actions>
            </v-stepper-content>
            <!-- FIM DO PASSO 4 -->

            <!-- PASSO 5 -->
            <v-stepper-content step="5">
              <v-card class="mb-5" min-height="200px" flat>
                <v-container grid-list-md>
                  <v-layout row wrap>
                    <v-flex xs12 sm12 lg12>
                      <p class="form-titulo" >Concluir Solicitação</p>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg8>
                      <iframe v-if="this.$vuetify.breakpoint.lg" :src="`${pdfSelecionado}`" width="680" height="400" style="border: none;"></iframe>
                    </v-flex>
                    <v-flex xs12 sm12 md12 lg4>
                      <div v-if="this.$vuetify.breakpoint.lg">
                        <v-list-tile
                          @click="pdfSelecionado = 'https://ecommerce.primavida.com.br/contratos/CREDENCIAMENTO/tabela_de_valores_primavida.pdf'" avatar
                        >
                          <v-list-tile-action>
                            <img src="../Content/images/pdf.png" width="30px">
                          </v-list-tile-action>
                          <v-list-tile-title>Tabela de Valores</v-list-tile-title>
                        </v-list-tile>
                      </div>
                    </v-flex>
                    <v-flex xs12 sm3 md12 lg12>
                      <v-checkbox v-model="contrataccept" color="#009B99">
                        <span slot="label">Li e concordo com os valores estabelecidos na tabela<!-- <a @click.stop :href="this.planoSelecionado[8]"
                        target="popup" 
                        :onclick="`window.open(${this.planoSelecionado[8]},popup,width=800,height=600); return false;`">termos do contrato</a> --></span>
                      </v-checkbox>
                    </v-flex>
                  </v-layout>
                </v-container>
                <v-card-actions>
                  <v-flex md12 xs12 sm12 lg3>
                    <v-btn style="border-radius: 8px;" large dark color="#009b9b" @click="finalizarCred()">Finalizar e Enviar</v-btn>
                  </v-flex>         
                </v-card-actions>
              </v-card>
            </v-stepper-content>
            <!-- FIM DO PASSO 5 -->
          </v-stepper-items>
        </v-stepper>

        <v-dialog v-model="dialogLoading" max-width="750px" max-height="500px" persistent> 
          <v-card style="border: 1px solid; border-color: #009b9b;border-radius: 10px;">
            <v-container grid-list-md>
              <v-layout row wrap justify-center>
                <v-card-title>
                  <span class="total" style="font-size:1.7rem;">Solicitação de credenciamento enviada com sucesso!</span>              
                </v-card-title>
                <v-container fluid justify-center class="resumo">
                  <p>Sua solicitação foi encaminhada para análise da Primavida Dental. Após a aprovação do credenciamento, um e-mail será enviado com as devidas instruções!</p>
                </v-container>
              </v-layout>
              <v-card-actions>
                <v-container fill-height fluid pa-1 justify-center>
                  <v-btn color="blue-grey darken-1" style="border-radius: 8px; width: 130px;" dark @click="fecharDialog()">Fechar</v-btn>
                </v-container>
              </v-card-actions>
            </v-container>
          </v-card>
        </v-dialog>
      </v-flex>
    </div>
    <loading :active.sync="isLoading" :can-cancel="true" color="#105586" :is-full-page="fullPage"></loading>
    <Snackbar ref=chamaSnackbar />
  </div>
</template>

<script>
  import FileUpload from 'vue-upload-component'
  import Snackbar from '../components/snackbar.vue'
  import axios from 'axios'
  import { mapState } from 'vuex'
  import { baseApiUrl } from '@/global'
  import CpfValidate from '../components/validators/rules/cpf'
  // Import component
  import Loading from 'vue-loading-overlay';
  // Import stylesheet
  import 'vue-loading-overlay/dist/vue-loading.css';
  export default {
    components: {Snackbar, Loading, FileUpload},
    data() {
      return {
        pdfSelecionado: 'https://ecommerce.primavida.com.br/contratos/CREDENCIAMENTO/tabela_de_valores_primavida.pdf',
        idFilial: '',
        filesRg1: [],
        filesRg2: [],
        filesCPF: [],
        filesCRO: [],
        filesINSS: [],
        filesAlvaraSan: [],
        filesAlvaraFun: [],
        filesComprovante: [],
        filesContrato: [],
        filesDiploma: [],
        filesDocCorpo: [],
        filesCNES: [],
        filesEspecializacao: [],
        corpoClinico: [],
        Anexos: {
          filialId: "ID_FILIAL",
          imagesDocs: {
            cpf: "",
            rg: "",
            rg2: "",
            cro: "",
            contrato: "",
            inss: "",
            alvaraSanitario: "",
            alvaraFuncionamento: "",
            comprovanteBancario: "",
            diploma: "",
            especializacao: "",
            cnes: "",
            docsCorpo: "",                  
          }
        },
        confirmPassword:'',
        fullPage: true,  
        isLoading: false,             
        cpf: '',
        senha: '', 
        tipoContrato: '',           
        exibeformulario: false,
        exibesenha: false,
        rowsPerPageItems: [12, 18],
        pagination: {
          rowsPerPage: 12
        },
        loadingFinal: false,
        loading: false,
        contrataccept: false,
        acceptTermos: false,
        alertTitular: false,
        editPassos: false,
        editedIndex: '',
        editedIndexTitular: '',
        dialog: false,
        dialogDelete: false,
        dialogLoading: false,
        dialogConfirmacao: false,
        codigoConfirmacao: '',
        codigoRecebido: '',
        e1: 0,
        bairro: '',
        cidade: '',
        estado: '',
        cep: '',
        estados: [],
        especialidadeClinica: [],
        generos: [
          { value: 1, text: "Masculino" },
          { value: 0, text: "Feminino" }
        ],
        modelFuncionario: {
          titular: false,
          nomeEmpregado: '',
          cd_tabela: '',
          logCep: '',
          chavE_TIPOLOGRADOURO: 0,
          endLogradouro: '',
          endNumero: 0,
          endComplemento: '',
          baiId: 0,
          cidID: 0,
          ufId: 0,
          nr_cpf: '',
          nr_identidade: '',
          nm_orgaoexp: '',
          cd_cargo: 0,
          cd_equipe: '',
          cro: '',
          dt_nascimento: '',
          cd_sexo: true,
          dt_contrato: '',
          cd_situacao: 1,
          dt_situacao: '',
          nm_titular_cta: '',
          cd_banco: '',
          nr_agencia: '',
          nr_conta: '',
          email: '',
          senha: '',
          nm_digital: '',
          bate_ponto: '',
          cd_faixa: 0,
          dia_Corte: 0,
          sequencial_Conta: '',
          sequencial_conta_interno: '',
          qT_BaixaProcedInterno: 0,
          qT_BaixaProcedCredenciado: 0,
          fl_permitemarcacao: '',
          observacao: '',
          cd_clinicapadrao: '',
          ramal: '',
          fl_bateponto: true,
          gfuId: '',
          vl_cm_dentista_exec: '',
          vl_cm_dentista_avali: '',
          fl_exibir_vl_cm_produt: '',
          nr_inss: '',
          cd_centro_custo: '',
          fl_foto: '',
          vl_cm_dentista_orto: '',
          nr_cnpj: '',
          pontuacao_dentista: 0,
          nr_contrato: '',
          qtLimiteBaixaEmPaciente: '',
          cd_situacao_entradaContrato: '',
          dt_descredenciamento: '',
          codExternoImportacao: '',
          cd_tab_comissao: '',
          dt_cadastro: '',
          cod_easy: '',
          fl_baixaadesao_automatico: 0,
          nm_reduzido: '',
          fl_rateio_produt: true,
          dt_alteracao_senha: '',
          executarTrigger: '',
          ufId_cro: '',
          geraComissao: true,
          exigeMeta: true,
          percComissao: '',
          perfilVendedor: 0,
          gerarGratificacaoClinicoPeriodo: '',
          conta_operacao: 0,
          metaNovosPacientes: 0,
          geraComissaoOrto: true,
          exigeMetaOrto: true,
          percComissaoOrto: '',
          perfilVendedorOrto: 0,
          gerarGratificacaoOrtoPeriodo: '',
          idModelo: '',
          percTaxaCredito: '',
          percTaxaDebito: '',
          tipoDeducao: '',
          deducao: '',
          cd_contabilidade: '',
          cd_tabela_contabilidade: '',
          operadorCallCenter: '',
          vl_descontoAdesaoProlabore: '',
          dt_limiteDescontoAdesaoProlabore: '',
          cidadeNaturalidade: '',
          ufNaturalidade: '',
          numeroTitulo: '',
          numeroZora: '',
          numeroSecao: '',
          cd_municipioTitulo: '',
          ufIdTitulo: '',
          arquivoExportacao: 0,
          geraComissaoOrtoAdesao: true,
          percComissaoOrtoAdesao: 0,
          exigeMetaOrtoAdesao: '',
          perfilVendedorOrtoAdesao: 0,
          gerarGratificacaoOrtoAdesaoPeriodo: '',
          cd_caixafinanceira: '',
          enderecoCarteira: true,
          qtdePesoProcedimentoProdutividade: '',
          idCBOS: '',
          iss: '',
          croDataExpedicao: '',
          pontoDeReferencia: '',
          nit_pis: '',
          sequencial_ContaVitalicio: '',
          forma_pagamento_comissao: '',
          contatos: [
            {
              tteSequencial: 0,
              Telefone: '',
              NmContato: '',
              fl_prioritario: false
            }
          ],
          filialId: '',
          especialidades: ''
        }, 
        modelFuncionarioDefault: {
          titular: false,
          nomeEmpregado: '',
          cd_tabela: '',
          logCep: '',
          chavE_TIPOLOGRADOURO: 0,
          endLogradouro: '',
          endNumero: 0,
          endComplemento: '',
          baiId: 0,
          cidID: 0,
          ufId: 0,
          nr_cpf: '',
          nr_identidade: '',
          nm_orgaoexp: '',
          cd_cargo: 0,
          cd_equipe: '',
          cro: '',
          dt_nascimento: '',
          cd_sexo: true,
          dt_contrato: '',
          cd_situacao: 1,
          dt_situacao: '',
          nm_titular_cta: '',
          cd_banco: '',
          nr_agencia: '',
          nr_conta: '',
          email: '',
          senha: '',
          nm_digital: '',
          bate_ponto: '',
          cd_faixa: 0,
          dia_Corte: 0,
          sequencial_Conta: '',
          sequencial_conta_interno: '',
          qT_BaixaProcedInterno: 0,
          qT_BaixaProcedCredenciado: 0,
          fl_permitemarcacao: '',
          observacao: '',
          cd_clinicapadrao: '',
          ramal: '',
          fl_bateponto: true,
          gfuId: '',
          vl_cm_dentista_exec: '',
          vl_cm_dentista_avali: '',
          fl_exibir_vl_cm_produt: '',
          nr_inss: '',
          cd_centro_custo: '',
          fl_foto: '',
          vl_cm_dentista_orto: '',
          nr_cnpj: '',
          pontuacao_dentista: 0,
          nr_contrato: '',
          qtLimiteBaixaEmPaciente: '',
          cd_situacao_entradaContrato: '',
          dt_descredenciamento: '',
          codExternoImportacao: '',
          cd_tab_comissao: '',
          dt_cadastro: '',
          cod_easy: '',
          fl_baixaadesao_automatico: 0,
          nm_reduzido: '',
          fl_rateio_produt: true,
          dt_alteracao_senha: '',
          executarTrigger: '',
          ufId_cro: '',
          geraComissao: true,
          exigeMeta: true,
          percComissao: '',
          perfilVendedor: 0,
          gerarGratificacaoClinicoPeriodo: '',
          conta_operacao: 0,
          metaNovosPacientes: 0,
          geraComissaoOrto: true,
          exigeMetaOrto: true,
          percComissaoOrto: '',
          perfilVendedorOrto: 0,
          gerarGratificacaoOrtoPeriodo: '',
          idModelo: '',
          percTaxaCredito: '',
          percTaxaDebito: '',
          tipoDeducao: '',
          deducao: '',
          cd_contabilidade: '',
          cd_tabela_contabilidade: '',
          operadorCallCenter: '',
          vl_descontoAdesaoProlabore: '',
          dt_limiteDescontoAdesaoProlabore: '',
          cidadeNaturalidade: '',
          ufNaturalidade: '',
          numeroTitulo: '',
          numeroZora: '',
          numeroSecao: '',
          cd_municipioTitulo: '',
          ufIdTitulo: '',
          arquivoExportacao: 0,
          geraComissaoOrtoAdesao: true,
          percComissaoOrtoAdesao: 0,
          exigeMetaOrtoAdesao: '',
          perfilVendedorOrtoAdesao: 0,
          gerarGratificacaoOrtoAdesaoPeriodo: '',
          cd_caixafinanceira: '',
          enderecoCarteira: true,
          qtdePesoProcedimentoProdutividade: '',
          idCBOS: '',
          iss: '',
          croDataExpedicao: '',
          pontoDeReferencia: '',
          nit_pis: '',
          sequencial_ContaVitalicio: '',
          forma_pagamento_comissao: '',
          contatos: [
            {
              tteSequencial: 0,
              Telefone: '',
              NmContato: '',
              fl_prioritario: false
            }
          ],
          filialId: '',
          especialidades: ''
        },    
        modelFilial: {
          nr_identidade: "",
          nm_orgaoexp: "",
          dt_nascimento: "",
          nr_cpf: "",
          nm_filial: "",
          nr_cgc: "",
          nm_responsavel: null,
          logCep: "",
          chavE_TIPOLOGRADOURO: 816,
          endLogradouro: "",
          endNumero: '',
          endComplemento: null,
          baiId: 0,
          cidID: 0,
          ufId: 0,
          cd_clinica: 2,
          fl_online: null,
          fl_consultorio: true,
          fl_ativa: 1,
          fl_DiasIntervaloConsultaVar: null,
          email: '',
          senha: "",
          url_mapalocalizacao: null,
          observacao: null,
          fl_biometria: false,
          flanalisaProcedimentoPag: false,
          cnes: "",
          cd_tipo_faturamento: 1,
          dt_corte: 4,
          nm_titular_cta: null,
          cd_banco: null,
          nr_agencia: null,
          nr_conta: null,
          dt_vencimento: 0,
          sequencial_Conta: null,
          vl_fixo_Produtividade: null,
          qt_incremento_mes_fatura: 0,
          nr_cpf_responsavel: null,
          cd_funcionario_responsavel: null,
          cd_centro_custo: 1,
          fl_orcamentoUnico: false,
          vl_teto_filial: null,
          tp_estabecimento: null,
          tp_contratacao: null,
          dt_contrato: null,
          dt_iniVinculo: null,
          cd_classificacao_est: null,
          nr_ANSinter: null,
          cd_dispon_serv: null,
          cd_ind_urgencia: null,
          cd_tipo_baixa_agenda: 2,
          fl_PesquisaOrtoOdontograma: true,
          fl_OdontogramaCompleto: true,
          cro_filial: null,
          nr_contrato: null,
          tp_relacaoContrato: null,
          cd_tabela: 19769,
          cd_modelo_biometria: null,
          fl_biometria_funcionario: 0,
          tbcId: null,
          alias_interno: null,
          cd_tabelaParticular: 1,
          nm_fantasia: "",
          qtdeDiasBaixaRetroativa: 0,
          qtdeBaixaPrestadorUsuario: null,
          referenciaLimiteBaixaPrestadorUsuario: null,
          qtdeMaximaBaixaUsuarioMes: null,
          tesId: null,
          tbcIdPendente: 4,
          tbcIdRealizado: 4,
          cd_filialSubstituta: null,
          dt_descredenciamento: null,
          fl_divulgar_rede_atendimento: null,
          nm_razsoc: "",
          cod_easy: null,
          validadeElegibilidade: null,
          tipoValidadeElegibilidade: null,
          tipoImpressaoGTO: 1,
          diasValidadeGTO: null,
          qtdeProcedimentosGTO: null,
          id_regiao: null,
          fl_OrcamentoFechaSemPagTotal: 1,
          qtDiasBloqueioProcedimento: null,
          dt_alteracao_senha: "",
          executarTrigger: false,
          exameConclusaoOdontograma: true,
          dataInicioCreditoOrto: null,
          atualizar_contato_dias: null,
          atualizar_contato_data_referencia: null,
          ufId_cro: null,
          conta_operacao: null,
          tipoAcaoBiometriaBaixaAgenda: null,
          cd_tabelaParceiro: null,
          exigirDocumentacaoProcedimento: 3,
          realizacaoProcedimentoSomenteAposUpload: 0,
          cd_tipoautorizador: null,
          pontuacao: null,
          classificacaoFilialDominio: null,
          cd_tabelaMicroCredito: null,
          latitude: null,
          longitude: null,
          tipoChecagemProcPendenteRepetido: null,
          idRegiaoEndereco: null,
          flPrioridade: null,
          dataInicioCreditoClinico: null,
          usuarioAtualizacao: 7021,
          dt_atualizacao: new Date().toISOString(),
          us_referencia: null,
          tipoRede: 2,
          nropres: null,
          nrolocal: null,
          biometriaFacial: 0,
          dataEmailBoasVindas: null,
          fl_cadastroANS: false,
          linkExterno: null,
          idGrupoClinica: null,
          imprimir_vl_GTO: true,
          qtdeProcedimentosGTOAcao: 1,
          qtdeProcedimentosGTOSituacao: 1,
          informacoesFinanceirasCorpoClinico: true,
          pontosMaximosProcedimentoUsuarioLote: 0,
          qtdeMaximaProcedimentoUsuarioLote: null,
          croDataExpedicao_filial: null,
          pontoDeReferencia: null,
          qtdeProcedimentosGTOTipoContagem: 1,
          regulamento: null,
          gtoDigital: null,
          fl_vip: null,
          pontuacao_estabelecimento: null,
          data_prioridade: null,
          contatos: [
            {
              tteSequencial: 1,
              Telefone: "",
              NmContato: "",
              fl_prioritario: false
            }
          ],
          especialidades:'',
          corpoClinicoFilial: [],
          vendedor: '',
          status: 'AGUARDANDO CONFIRMAÇÃO',
        },
        bancos: [],
        dictionary: {
          custom: {
            uf: {
              required: () => 'Informe a UF',
            },
            firstName: {
              required: () => 'Informe o Nome',                   
            },
            email: {
              required: () => 'Informe o Email',
              email: () => 'Informe um Email válido'
            },
            telefone: {
              required: () => 'Informe o Telefone',                   
            },
            password: {
              required: () => 'Informe a Senha',
              confirmed: () => 'A senha não confere'
            },
            senha: {
              required: () => 'Informe a Senha'
            },
            cep: {
              required: () => 'Informe o CEP'
            },
            numero: {
              required: () => 'Informe o Número, caso não tenha informe 0'
            },
            cro: {
              required:() => 'Informe o número do CRO'
            },
            cnes: {
              required:() => 'Informe o CNES'
            },  
            emissao: {
              required:() => 'Informe data de emissão do CRO'
            }, 
            responsavel: {
              required:() => 'Informe o nome do reponsável técnico'
            },    
            especialidade: {
              required:() => 'Informe a(s) especialidade(s)'
            },
            cnpj: {
              required:() => 'Informe o CNPJ'
            },
            cpfFilial: {
              required:() => 'Informe o CPF'
            },
            especialidadeCC: {
              required:() => 'Informe a(s) especialidade(s)'
            },
            dateOfBirth: {
              required:() => 'Informe a data de Nascimento'
            },
            dateOfBirthCC: {
              required:() => 'Informe a data de Nascimento'
            },
            rg: {
              required:() => 'Informe o número do RG'
            },
            rgCC: {
              required:() => 'Informe o número do RG'
            },
            cpfCC: {
              required:() => 'Informe o CPF'
            },
            orgao: {
              required:() => 'Informe o órgao emissor'
            },
            orgaoCC: {
              required:() => 'Informe o órgao emissor'
            },
            bancoPF: {
              required: () => 'Informe o banco',
            },
            agenciaPF: {
              required: () => 'Informe a agência',
            },
            contaPF: {
              required: () => 'Informe a conta',
            },
            bancoPJ: {
              required: () => 'Informe o banco',
            },
            agenciaPJ: {
              required: () => 'Informe a agência',
            },
            contaPJ: {
              required: () => 'Informe a conta',
            },
          }
        } 
      }
    },

    mounted : function() {
      this.$store.dispatch('ExibeToolbar')
      this.$validator.localize('pt', this.dictionary)
      localStorage.clear()
      sessionStorage.clear() 
      this.pegaParametrosUrl()
      this.carregaDados()
      this.pegaBancos()
    },

    watch: {
      dialog(val) {
        val || this.close()
      },

      cep() {
        if (this.cep.length == 9)
          this.retornoViaCEP()
      }
    },

    computed: {
      ...mapState({
        userloggedin: state => state.userloggedin
      }),

      formTitle() {
        return this.editedIndex === '' ? 'Incluir Corpo Clínico' : 'Editar Corpo Clínico'
      },

      minHeight () {
        switch (this.$vuetify.breakpoint.name) {
          case 'xs': return '800px'
          case 'sm': return '800px'
          case 'md': return '800px'
          case 'lg': return '800px'
          case 'xl': return '800px'
        }
        return true
      }
    },

    methods: {
      editItem(item) {
        this.editedIndex = item.id
        this.modelFuncionario = Object.assign({}, item)
        this.dialog = true
      },

      async deleteDependente(firstName) {             
        this.dependentes.forEach( (item, index) => {
        // se o id do array de objetos estiver em a1
        if (item.firstName == firstName)
          this.dependentes.splice(index,1) // entao remove                             
        })
      },

      async carregaDados() {
        await axios.get(`${baseApiUrl}UFs`).then(res => {        
          if (res.data != null) {
            this.estados = res.data
            //this.financialManagers.plansId = this.planoSelecionado.id
          }
        })
      },
          
      avancaPasso1() {
        if (this.tipoContrato == 'FÍSICA') {                     
          if (this.modelFuncionario.nomeEmpregado == '' || this.modelFuncionario.cro == '' || this.modelFuncionario.croDataExpedicao == '' || this.modelFuncionario.nr_identidade == '' || this.modelFuncionario.nm_orgaoexp == '' || this.modelFuncionario.dt_nascimento == '' || this.modelFuncionario.nr_cpf == '' || this.modelFilial.email == '' || this.modelFuncionario.nit_pis == '' || this.modelFilial.senha == '' || this.confirmPassword == '' || this.modelFilial.especialidades == '' || this.modelFilial.contatos[0].NmContato == '' || this.modelFilial.contatos[0].Telefone == '' || !CpfValidate(this.modelFuncionario.nr_cpf) || this.modelFuncionario.cd_banco == '' || this.modelFuncionario.nr_agencia == '' || this.modelFuncionario.nr_conta == '')
            this.$validator.validateAll()
          else            
            this.e1 = 2
        } else {
          if (this.modelFilial.email == '' || this.modelFilial.senha == '' || this.confirmPassword == '' || this.modelFilial.nm_razsoc == '' || this.modelFilial.especialidades == '' || this.modelFilial.contatos[0].NmContato == '' || this.modelFilial.contatos[0].Telefone == '' || this.modelFilial.cnpj == '' || this.modelFilial.cnes == ''  || this.modelFilial.cd_banco == null || this.modelFilial.nr_agencia == null || this.modelFilial.nr_conta == null)
            this.$validator.validateAll()
          else            
            this.e1 = 2
        }
      },

      async avancaPasso2() {
        if (this.cep == '' || this.modelFilial.endLogradouro == '' || this.modelFilial.baiId == '' || this.modelFilial.endNumero == '' || this.modelFilial.cidID == '' || this.modelFilial.ufId == '')
          this.$validator.validateAll()
        else
          this.e1 = 3
        // try {
        //     this.isLoading = true
        //     let res = await axios.post(`${baseApiUrl}Filials/replaceOrCreate`, this.modelFilial)
        //     if(res.data != ''){
        //       this.idFilial = res.data.id
        //       this.Anexos.filialId = this.idFilial
        //       this.e1 = 3
        //       this.isLoading = false
        //     }
            
        //   } catch (error) {
        //       this.isLoading = false
        //       var vm = this;
        //       vm.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar Filial!","ERRO");
        //   }
      },

      async avancaPasso3() {
        this.isLoading = true
        if (this.tipoContrato == 'FÍSICA') {
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.cro = document.getElementById("cro").value
          this.Anexos.imagesDocs.inss = document.getElementById("inss").value
          this.Anexos.imagesDocs.alvaraFuncionamento = document.getElementById("alvarafun").value
          this.Anexos.imagesDocs.alvaraSanitario = document.getElementById("alvarasan").value
          this.Anexos.imagesDocs.comprovanteBancario = document.getElementById("comprovante").value
          this.Anexos.imagesDocs.especializacao = document.getElementById("especializacao").value
          this.Anexos.imagesDocs.diploma = document.getElementById("diploma").value
          if (this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.cro == undefined || this.Anexos.imagesDocs.inss == undefined || this.Anexos.imagesDocs.alvaraFuncionamento == undefined || this.Anexos.imagesDocs.alvaraSanitario == undefined || this.Anexos.imagesDocs.comprovanteBancario == undefined || this.Anexos.imagesDocs.diploma == undefined) {
            this.isLoading = false
            var vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            if (this.tipoContrato == 'JURÍDICA')
              this.e1 = 4
            else
              this.e1 = 5
            /* try {
              let res = await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`,this.Anexos )
              if (res.data != '') { */
                this.modelFuncionario.titular = true
                this.modelFuncionario.nomeEmpregado = this.modelFilial.nm_filial
                this.modelFuncionario.nr_identidade = this.modelFilial.nr_identidade
                this.modelFuncionario.nm_orgaoexp = this.modelFilial.nm_orgaoexp
                this.modelFuncionario.nr_cpf = this.modelFilial.nr_cpf
                this.modelFuncionario.dt_nascimento = this.modelFilial.dt_nascimento
                this.modelFuncionario.cro = this.modelFilial.cro_filial
                this.modelFuncionario.especialidades = this.modelFilial.especialidades
                this.isLoading = false
                /* this.salvarCorpoClinicoPF()
                if (this.tipoContrato == 'JURÍDICA')
                  this.e1 = 4
                else
                  this.e1 = 5
                this.isLoading = false
              }
            } catch (error) {
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar anexos!","ERRO");
            } */
          }
        } else {
          this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
          this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
          this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
          this.Anexos.imagesDocs.cro = document.getElementById("cro").value
          this.Anexos.imagesDocs.contrato = document.getElementById("contrato").value
          this.Anexos.imagesDocs.alvaraFuncionamento = document.getElementById("alvarafun").value
          this.Anexos.imagesDocs.alvaraSanitario = document.getElementById("alvarasan").value
          this.Anexos.imagesDocs.comprovanteBancario = document.getElementById("comprovante").value
          this.Anexos.imagesDocs.especializacao = document.getElementById("especializacao").value
          this.Anexos.imagesDocs.docsCorpo = document.getElementById("docscorpo").value
          this.Anexos.imagesDocs.cnes = document.getElementById("cnes").value
          if (this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.cro == undefined || this.Anexos.imagesDocs.contrato == undefined || this.Anexos.imagesDocs.alvaraFuncionamento == undefined || this.Anexos.imagesDocs.alvaraSanitario == undefined || this.Anexos.imagesDocs.comprovanteBancario == undefined || this.Anexos.imagesDocs.docsCorpo == undefined || this.Anexos.imagesDocs.cnes == undefined) {
            this.isLoading = false
            vm2 = this;
            vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar é necessário enviar todos os arquivos!","ATENÇÃO")
          } else {
            if (this.tipoContrato == 'JURÍDICA')
              this.e1 = 4
            else
              this.e1 = 5
            this.isLoading = false
            /* try {
              let res = await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`,this.Anexos )
              if (res.data != '') {
                if (this.tipoContrato == 'JURÍDICA')
                  this.e1 = 4
                else
                  this.e1 = 5
                this.isLoading = false
              }
            } catch (error) {
              vm2 = this;
              vm2.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar anexos!","ERRO");
            } */
          }
        }
      },

      avancaPasso4() {
        if (this.modelFilial.corpoClinicoFilial == '') {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário incluir o corpo clínico.","ATENÇÃO");
        } else {
          this.e1 = 5
        }
      },

      async salvarDocs() {
        try {
          let res = await axios.post(`${baseApiUrl}ImagesDocs/saveDocsFinancialManager`, this.Anexos )
          if (res.data != '') {
            await axios.post(`${baseApiUrl}Filials/update?[where][id]=${this.idFilial}`, {"saveFile" : true})
          }
        } catch (error) {
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack("#EF5350","Erro ao salvar anexos!","ERRO");
        }
      },

      async finalizarCred() {
        if (this.modelFilial.corpoClinicoFilial == '') {
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário incluir o corpo clínico.","ATENÇÃO");
        } else {
          this.isLoading = true
          try {
            this.modelFilial.nm_filial = this.modelFilial.nm_razsoc
            let res = await axios.post(`${baseApiUrl}Filials/CadastrarFilialFunc`, this.modelFilial ) 
            if (res.data != '') {
              this.Anexos.filialId = res.data.filial.id
              this.idFilial = res.data.filial.id
              this.salvarDocs()
              this.isLoading = false
              this.dialogLoading = true
            }         
          } catch (error) {
            this.isLoading = false
            vm = this;
            vm.$refs.chamaSnackbar.snack("#F9A825","Erro ao finalizar solicitação, tente novamente","ATENÇÃO")                   
          }
        }
      },

      async finalizarCredPF() {
        this.isLoading = true
        this.Anexos.imagesDocs.rg = document.getElementById("rg1").value
        this.Anexos.imagesDocs.rg2 = document.getElementById("rg2").value
        this.Anexos.imagesDocs.cpf = document.getElementById("cpf").value
        this.Anexos.imagesDocs.cro = document.getElementById("cro").value
        this.Anexos.imagesDocs.inss = document.getElementById("inss").value
        this.Anexos.imagesDocs.alvaraFuncionamento = document.getElementById("alvarafun").value
        this.Anexos.imagesDocs.alvaraSanitario = document.getElementById("alvarasan").value
        this.Anexos.imagesDocs.comprovanteBancario = document.getElementById("comprovante").value
        this.Anexos.imagesDocs.especializacao = document.getElementById("especializacao").value
        this.Anexos.imagesDocs.diploma = document.getElementById("diploma").value
        if (this.Anexos.imagesDocs.rg == undefined || this.Anexos.imagesDocs.rg2 == undefined || this.Anexos.imagesDocs.cpf == undefined || this.Anexos.imagesDocs.cro == undefined || this.Anexos.imagesDocs.inss == undefined || this.Anexos.imagesDocs.alvaraFuncionamento == undefined || this.Anexos.imagesDocs.alvaraSanitario == undefined || this.Anexos.imagesDocs.comprovanteBancario == undefined || this.Anexos.imagesDocs.diploma == undefined) {
          this.isLoading = false
          var vm2 = this;
          vm2.$refs.chamaSnackbar.snack("#F9A825","Para continuar, é necessário enviar todos os arquivos!","ATENÇÃO")
        } else {
          this.isLoading = true
          // inserindo informações do modelFilial no modelFuncionario
          this.modelFuncionario.email = this.modelFilial.email
          this.modelFuncionario.senha = this.modelFilial.senha
          this.modelFuncionario.especialidades = this.modelFilial.especialidades
          // this.modelFuncionario.croDataExpedicao = this.modelFilial.croDataExpedicao_filial
          this.modelFuncionario.contatos[0].NmContato = this.modelFilial.contatos[0].NmContato
          this.modelFuncionario.contatos[0].Telefone = this.modelFilial.contatos[0].Telefone
          this.modelFuncionario.senha = this.modelFilial.senha
          this.modelFilial.logCep = this.cep
          this.modelFuncionario.logCep = this.modelFilial.logCep
          this.modelFuncionario.chavE_TIPOLOGRADOURO = this.modelFilial.chavE_TIPOLOGRADOURO
          this.modelFuncionario.endLogradouro = this.modelFilial.endLogradouro
          this.modelFuncionario.endNumero = this.modelFilial.endNumero
          this.modelFuncionario.endComplemento = this.modelFilial.endComplemento
          this.modelFuncionario.baiId = this.modelFilial.baiId
          this.modelFuncionario.cidID = this.modelFilial.cidID
          this.modelFuncionario.ufId = this.modelFilial.ufId
          await this.salvarCorpoClinicoPF()
          this.isLoading = false
          this.dialogLoading = true
        }
      },

      fecharDialog() {
        this.dialogLoading = false
        setTimeout(() => {
          document.location.reload(true);
        }, 500);
      },

      async salvarCorpoClinicoPF() {
        if (this.modelFuncionario.nomeEmpregado == '' || this.modelFuncionario.nr_identidade == '' || this.modelFuncionario.nm_orgaoexp == '' || this.modelFuncionario.nr_cpf == '' || this.modelFuncionario.dt_nascimento == '' || this.modelFuncionario.cro == '' || this.modelFuncionario.especialidades == '') {
          this.$validator.validateAll()
        } else {
          try {
            this.modelFuncionario.filialId = this.filialId
            // this.modelFuncionario.croDataExpedicao = this.modelFilial.croDataExpedicao_filial
            let res = await axios.post(`${baseApiUrl}FuncionarioFilials/CadastrarFuncFilial`, this.modelFuncionario)
            if (res.data != '') {
              this.Anexos.filialId = res.data.filial.id
              this.idFilial = res.data.filial.id
              this.salvarDocs()
              this.close()
              this.isLoading = false
              //this.carregaCorpoClinico()
            }
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar o funcionário","ERRO") 
          }
        }
      },

      async salvarCorpoClinicoPJ() {
        if (this.modelFuncionario.nomeEmpregado == '' || this.modelFuncionario.nr_identidade == '' || this.modelFuncionario.nm_orgaoexp == '' || this.modelFuncionario.nr_cpf == '' || this.modelFuncionario.dt_nascimento == '' || this.modelFuncionario.cro == '' || this.modelFuncionario.especialidades == '' || this.modelFuncionario.croDataExpedicao == '' || this.modelFuncionario.cd_banco == '' || this.modelFuncionario.nr_agencia == '' || this.modelFuncionario.nr_conta == '') {
          this.$validator.validateAll()
        } else {
          try {
            this.modelFuncionario.filialId = this.idFilial
            // this.corpoClinico.push(this.modelFuncionario)
            this.modelFilial.corpoClinicoFilial.push(this.modelFuncionario)
            this.close()
            /* let res = await axios.post(`${baseApiUrl}FuncionarioFilials/CadastrarFuncFilial`, this.modelFuncionario)
            if (res.data != '') {
              this.close()
              this.carregaCorpoClinicoPJ()
            } */
          } catch (error) {
            var vm = this;
            vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao salvar o funcionário","ERRO")
          }
        }
      },

      async carregaCorpoClinico() {
        this.isLoading = true
        try {
          let res = await axios.get(`${baseApiUrl}FuncionarioFilials?filter[where][filialId]=${this.idFilial}`)
          if (res.data != null) {
            this.corpoClinico = res.data   
            this.isLoading = false         
          }             
        } catch (error) {
          this.isLoading = false
          var vm = this;
          vm.$refs.chamaSnackbar.snack("#EF5350","Desculpe, ocorreu um problema ao carregar o corpo clínico","ERRO") 
        }
      },
      
      async carregaEspecialidades() {
        await axios.get(`${baseApiUrl}APIS4s/Especialidades`).then(res => {
          if (res.data != null) {
            for (let i = 0; i < res.data.length; i++) {
              this.especialidadeClinica.push({
                value: res.data[i].Id,
                text: res.data[i].Nome
              })
            }
          }
        })
      },

      formatDate (date) {
        if (!date) return null

        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
      },

      formatDateBrz (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },

      async retornoViaCEP() {
        this.isLoading = true
        await axios.post(`${baseApiUrl}APIS4s/Endereco`, {"cep" : this.cep}).then(res => {
          if (res.data != null) {
            this.isLoading = false
            this.modelFilial.logCep = this.cep   
            this.modelFilial.baiId = res.data.IdBairro
            this.modelFilial.cidID = res.data.IdMunicipio
            this.modelFilial.ufId = res.data.IdUf
            this.modelFilial.endLogradouro = res.data.Logradouro
            this.bairro = res.data.Bairro
            this.cidade = res.data.Municipio
            this.estado = res.data.Uf
          } else {
            this.isLoading = false
            var vmcep = this;
            vmcep.$refs.chamaSnackbar.snack("#F9A825","CEP não localizado!","ATENÇÃO")
          }         	
        })       
      },

      openDialogCorpoClinico() {
        this.$validator.reset()          
        this.dialog = true
      },

      openDialogDelete(item) {
        this.editedIndex = item.id
        this.dependents = Object.assign({}, item)
        this.$validator.reset()
        this.dialogDelete = true
      },

      close() {
        this.dialogDelete = false
        this.dialogLoading = false
        this.dialog = false
        this.$validator.reset()          
        setTimeout(() => {
          this.modelFuncionario = Object.assign({}, this.modelFuncionarioDefault)
        }, 300)
      },

      async iniciarCredenciamento(tipoContratacao) {
        if (tipoContratacao == 'fisica')
          this.tipoContrato  = 'FÍSICA'
        else
          this.tipoContrato = 'JURÍDICA'
        this.exibeformulario = true
        this.carregaEspecialidades()
      },

      //CONTROLE DE ANEXOS
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          // Before adding a file
          // Filter system files or hide files
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          // Filter php html js file
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      
      inputFileRg1(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesRg1[0]
          //salva a base64 na variável
          reader.onloadend = function() {
            document.getElementById("rg1").value = reader.result
          };
          //Gera base64
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },
      
      inputFileRg2(newFile, oldFile) {
        if (newFile && !oldFile) {        
          var reader = new FileReader();        
          var file = this.filesRg2[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("rg2").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCPF(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesCPF[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("cpf").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCRO(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesCRO[0]
          //Gera base64
          reader.onloadend = function() {
            document.getElementById("cro").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileINSS(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesINSS[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("inss").value = reader.result
          };
          reader.readAsDataURL(file.file);  
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileAlvaraSan(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesAlvaraSan[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("alvarasan").value = reader.result
          };
          reader.readAsDataURL(file.file);  
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileAlvaraFun(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesAlvaraFun[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("alvarafun").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []  
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileComprovante(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesComprovante[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("comprovante").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileDiploma(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesDiploma[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("diploma").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileEspecializacao(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesEspecializacao[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("especializacao").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileContrato(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesContrato[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("contrato").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileDocCorpo(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesDocCorpo[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("docscorpo").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },

      inputFileCNES(newFile, oldFile) {
        if (newFile && !oldFile) {
          var reader = new FileReader();
          var file = this.filesCNES[0]
          //Gera base643
          reader.onloadend = function() {
            document.getElementById("cnes").value = reader.result
          };
          reader.readAsDataURL(file.file);
          //this.files = []
        }
        if (newFile && oldFile) {
          // update
        }
        if (!newFile && oldFile) {
          // remove
        }
      },
      //FIM CONTROLE DE ANEXOS

      async pegaParametrosUrl() {
        var params = window.location.search.substring(1).split('&');
        if (params[0] != '') {
          //Criar objeto que vai conter os parametros
          var paramArray = {};
          //Passar por todos os parametros
          for (var i = 0; i < params.length; i++) {
            //Dividir os parametros chave e valor
            var param = params[i].split('=');
            //Adicionar ao objeto criado antes
            paramArray[param[0]] = param[1];
          }
          if (paramArray['vendedor']) {
            await axios.get(`${baseApiUrl}Salesmans?filter[where][linkSite]=${paramArray['vendedor']}`).then(response => {
              if (response.data) {
                this.modelFilial.vendedor = response.data[0].linkSite
              }
            })
          }
        }
      },

      async pegaBancos() {
        await axios.get('https://brasilapi.com.br/api/banks/v1').then(response => {
          if (response.data) {
            for (let i = 0; i < response.data.length; i++) {
              if (response.data[i].code) {
                this.bancos.push({
                  "value": response.data[i].code,
                  "text": response.data[i].code + ' - ' + response.data[i].name,
                })
              }
            }
            this.bancos = this.bancos.sort(function (a, b) {
              if (a.value > b.value) {
                return 1;
              }
              if (a.value < b.value) {
                return -1;
              }
              // a must be equal to b
              return 0;
            });
          }
        })
      },
    }
  }
</script>

<style>
  .link {
    font-size: 1.3rem;
    color: #009b9b;
    text-align: center;
  }

  .titulo {
    font-size: 2rem;
    color: #797a7a;
    text-align: center;
  }

  .imagemcaarj {
    background: url('https://www.apvs.com.br/assets/uploads/parceiros/caarj.png')no-repeat;
    background-size: 500px;
  }

  .imagemBanner {
    background: url("../Content/images/bannerCredenciamento.png");
    background-repeat: no-repeat;
    position: relative;
    z-index: 1;
  }
</style>